import React, { useState } from "react";
import Sidebar from "../DesignSystem/Sidebar/Sidebar";
import Banner from "../Components/Banners/Banner";
import "../../css/Pages/Guide.css";
import { ReactComponent as InfoIcon } from "../../assets/icons/information.svg";
import PrimaryButton from "../Components/Buttons/PrimaryButton";
import CheckHelpModal from "../Checks/Components/CheckHelpModal.jsx";
import { ReactComponent as Logo } from "../../assets/icons/logo.svg";
import { useCheck2GuideUrl } from "../Checks/utils/guide/getUrl.js";
import { Helmet } from "react-helmet-async";

const Guide = () => {
    const [showHelp, setShowHelp] = useState(false);
    const GUIDE_URL = useCheck2GuideUrl();

  return (
    <div className="Main-Page">
          <Helmet>
              <title>Guide</title>
              <meta name="description" content="check²" />
            </Helmet>
      
      <Sidebar />
      <div className="guide-container">
        <Logo className="guide-logo" />
        <div className="guide-actions">
          <PrimaryButton label="Help" onClick={() => setShowHelp(true)} />
          <a
            href={GUIDE_URL}
            download
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <PrimaryButton label="Download Guide" />
          </a>
        </div>
        <CheckHelpModal open={showHelp} onClose={() => setShowHelp(false)} />
        <Banner
          type="info"
          message={
            <span>
              Need more help? Email{" "}
              <a
                href="mailto:Support@check2.co.uk"
                style={{ color: "#0078d4", textDecoration: "underline" }}
              >
                Support@check2.co.uk
              </a>{" "}
              or refer to the downloaded guide.
            </span>
          }
        />
      </div>
    </div>
  );
};

export default Guide;
